export default class SubscriberFormSummaryCtrl {
    constructor($scope, $stateParams, $state, SideMenu, SubscriberForm) {
        SideMenu.setActive('subscriber');

        this._stateParams = $stateParams;
        this._state = $state;
        this._scope = $scope;

        this.status = 'summary';

        SubscriberForm.find($stateParams.id, [ 'settings', 'email', 'fields', 'language' ]).then((subscriberForm) => {
            this.subscriberForm = subscriberForm.data;
        });

        this._scope.$on('subscriberForm:goTo', (event, toState) => {
            return this.goTo(toState);
        });

        this._scope.$on('account:changed', () => {
            this._state.go('subscriberForm.index');
        });
    }


    goTo(page) {
        switch (page) {
            case 'email':
                if (this.subscriberForm.email) {
                    this._state.go('subscriberForm.email.edit', {
                        id: this._stateParams.id,
                        emailId: this.subscriberForm.email.id
                    });
                } else {
                    this._state.go('subscriberForm.email', { id: this._stateParams.id });
                }
                break;
            case 'builder':
                this._state.go('subscriberForm.edit', { id: this._stateParams.id });
                break;
            default:
                this._state.go('subscriberForm.' + page, { id: this._stateParams.id });
        }
    };
};
